export default class Padding {
    constructor(data) {
        this.padding = `${data.top}px ${data.right}px ${data.bottom}px ${data.left}px`
    }
}